"use client";

import React from "react";
import { Box } from "@mui/material";
import Navbar from "./Navbar";
import Footer from "./Footer";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({
  children,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Navbar at the top */}
      <Navbar />

      {/* Page Content */}
      <Box sx={{ flexGrow: 1, paddingBottom: "40px" }}>
        {children}
      </Box>

      {/* Footer fixed at bottom */}
      <Footer
      />
    </Box>
  );
};

export default Layout;
